(function() {
  let observer = null;
  
  function getButtonText() {
    const sizeOptionPortal = document.querySelector('#size-option .form__label .nm-portal[data-portal-location="size-option"]');
    if (sizeOptionPortal && sizeOptionPortal.dataset.buttonText) {
      return sizeOptionPortal.dataset.buttonText;
    }
    return 'La taglia che cerchi è esaurita. <u>Clicca qui</u> per essere avvisato quando torna disponibile.';
  }
  
  function updateButtonTextAndStyle(button) {
    const ORIGINAL_BUTTON_TEXT = getButtonText();
    button.innerHTML = ORIGINAL_BUTTON_TEXT;
    
    button.style.font = 'normal normal normal 14px/18px "Neue Haas Grotesk Display Pro", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
    button.style.letterSpacing = '0px';
    button.style.backgroundColor = '#EFEFEF';
    button.style.border = 'none';
    button.style.whiteSpace = 'normal';
    button.style.textAlign = 'start';
    button.style.padding = '12px 16px';
    button.style.color = '#7C7C7C';
    button.style.textTransform = 'none';
    button.style.maxWidth = '300px';
    button.style.display = 'inline-block';
    button.style.verticalAlign = 'middle';
    button.style.marginLeft = '12px';
    button.style.borderRadius = '8px';
    
    const textObserver = new MutationObserver((mutations) => {
      const currentText = getButtonText();
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          if (button.innerHTML !== currentText) {
            button.innerHTML = currentText;
          }
        }
      });
    });
    
    textObserver.observe(button, {
      childList: true,
      subtree: true,
      characterData: true
    });
    
    button.addEventListener('click', (e) => {
      const currentText = getButtonText();
      setTimeout(() => {
        if (button.innerHTML !== currentText) {
          button.innerHTML = currentText;
        }
      }, 50);
      setTimeout(() => {
        if (button.innerHTML !== currentText) {
          button.innerHTML = currentText;
        }
      }, 200);
      setTimeout(() => {
        if (button.innerHTML !== currentText) {
          button.innerHTML = currentText;
        }
      }, 500);
    });
  }
  
  function stylePortalContainer() {
    const sizeOptionLabel = document.querySelector('#size-option .form__label');
    const sizeOptionPortal = document.querySelector('#size-option .form__label .nm-portal[data-portal-location="size-option"]');
    if (sizeOptionLabel && sizeOptionPortal) {
      sizeOptionLabel.style.display = 'flex';
      sizeOptionLabel.style.alignItems = 'end';
      sizeOptionLabel.style.justifyContent = 'start';
      sizeOptionLabel.style.width = '100%';
      sizeOptionPortal.style.display = 'inline-block';
      sizeOptionPortal.style.marginLeft = 'auto';
      
      if (sizeOptionPortal.style.display !== 'none' && getComputedStyle(sizeOptionPortal).display !== 'none') {
        sizeOptionPortal.style.pointerEvents = 'auto';
      }
    }
  }
  
  
  let activeLabelForPortal = null;
  
  function updatePortalTranslateX(labelElement) {
    const sizeOptionPortal = document.querySelector('#size-option .form__label .nm-portal[data-portal-location="size-option"]');
    if (!sizeOptionPortal || !labelElement) return;
    
    
    activeLabelForPortal = labelElement;
    
    
    const labelRect = labelElement.getBoundingClientRect();
    const sizeOptionFieldset = document.querySelector('#size-option');
    
    if (!sizeOptionFieldset) return;
    
    const fieldsetRect = sizeOptionFieldset.getBoundingClientRect();
    
    
    const labelCenterX = labelRect.left + labelRect.width / 2 - fieldsetRect.left;
    
    
    const portalLeft = parseFloat(getComputedStyle(sizeOptionPortal).getPropertyValue('--popup-left') || '0');
    
    
    const calculatePosition = () => {
      const portalRect = sizeOptionPortal.getBoundingClientRect();
      const portalWidth = portalRect.width || sizeOptionPortal.offsetWidth || 0;
      
      
      if (portalWidth > 0) {
        
        const translateX = labelCenterX - portalLeft - (portalWidth / 2);
        const translateXPercent = (translateX / portalWidth) * 100;
        sizeOptionPortal.style.setProperty('--popup-translate-x', `${translateXPercent}%`);
      }
    };
    
    
    calculatePosition();
    setTimeout(calculatePosition, 10);
    setTimeout(calculatePosition, 50);
    setTimeout(calculatePosition, 100);
    setTimeout(calculatePosition, 200);
  }
  
  function attachLabelListeners() {
    const sizeVariantLabels = document.querySelectorAll('#size-option .product__size-variant-label');
    
    sizeVariantLabels.forEach(label => {
      
      if (label.dataset.translateXListener === 'true') return;
      label.dataset.translateXListener = 'true';
      
      
      label.addEventListener('click', () => {
        updatePortalTranslateX(label);
        
        setTimeout(ensurePortalClickable, 10);
        setTimeout(ensurePortalClickable, 50);
      });
      
      
      label.addEventListener('mouseenter', () => {
        if (label.classList.contains('product__size-variant-label--disabled')) {
          updatePortalTranslateX(label);
        }
      });
    });
  }
  
  function initPortalPositioning() {
    
    attachLabelListeners();
    
    
    const sizeOptionPortal = document.querySelector('#size-option .form__label .nm-portal[data-portal-location="size-option"]');
    const sizeOptionWrapper = document.querySelector('#size-option .product__size-variant-wrapper');
    
    if (sizeOptionPortal) {
      
      let previousPopupLeft = parseFloat(getComputedStyle(sizeOptionPortal).getPropertyValue('--popup-left') || '0');
      
      
      const portalObserver = new MutationObserver(() => {
        const currentPopupLeft = parseFloat(getComputedStyle(sizeOptionPortal).getPropertyValue('--popup-left') || '0');
        const isVisible = sizeOptionPortal.style.display !== 'none' && 
                         getComputedStyle(sizeOptionPortal).display !== 'none';
        
        
        if (isVisible) {
          ensurePortalClickable();
        }
        
        
        if (currentPopupLeft !== previousPopupLeft && isVisible && activeLabelForPortal) {
          previousPopupLeft = currentPopupLeft;
          updatePortalTranslateX(activeLabelForPortal);
        } else if (isVisible && activeLabelForPortal) {
          
          updatePortalTranslateX(activeLabelForPortal);
        } else if (isVisible) {
          
          const activeLabel = document.querySelector('#size-option .product__size-variant-input:checked + .product__size-variant-label') ||
                             document.querySelector('#size-option .product__size-variant-label--disabled');
          if (activeLabel) {
            updatePortalTranslateX(activeLabel);
          }
        }
      });
      
      portalObserver.observe(sizeOptionPortal, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true
      });
      
      
      if (window.ResizeObserver) {
        const resizeObserver = new ResizeObserver(() => {
          if (activeLabelForPortal) {
            const isVisible = sizeOptionPortal.style.display !== 'none' && 
                             getComputedStyle(sizeOptionPortal).display !== 'none';
            if (isVisible) {
              updatePortalTranslateX(activeLabelForPortal);
            }
          }
        });
        resizeObserver.observe(sizeOptionPortal);
      }
    }
    
    
    if (sizeOptionWrapper) {
      const wrapperObserver = new MutationObserver(() => {
        attachLabelListeners();
        
        const sizeOptionPortal = document.querySelector('#size-option .form__label .nm-portal[data-portal-location="size-option"]');
        if (sizeOptionPortal && activeLabelForPortal) {
          const isVisible = sizeOptionPortal.style.display !== 'none' && 
                           getComputedStyle(sizeOptionPortal).display !== 'none';
          if (isVisible) {
            updatePortalTranslateX(activeLabelForPortal);
          }
        }
      });
      
      wrapperObserver.observe(sizeOptionWrapper, {
        childList: true,
        subtree: true
      });
    }
  }
  
  function ensurePortalClickable() {
    const sizeOptionPortal = document.querySelector('#size-option .form__label .nm-portal[data-portal-location="size-option"]');
    if (!sizeOptionPortal) return;
    
    const isVisible = sizeOptionPortal.style.display !== 'none' && 
                     getComputedStyle(sizeOptionPortal).display !== 'none';
    
    if (isVisible) {
      
      sizeOptionPortal.style.pointerEvents = 'auto';
      
      
      const buttons = sizeOptionPortal.querySelectorAll('.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button');
      buttons.forEach(button => {
        button.style.pointerEvents = 'auto';
        button.style.cursor = 'pointer';
      });
    }
  }
  
  function moveButtonToSizeOption() {
    const sizeOptionPortal = document.querySelector('#size-option .form__label .nm-portal[data-portal-location="size-option"]');
    if (!sizeOptionPortal) return;
    
    const existingButtons = sizeOptionPortal.querySelectorAll('.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button');
    if (existingButtons.length > 1) {
      for (let i = 1; i < existingButtons.length; i++) {
        existingButtons[i].remove();
      }
    }
    
    const buttons = document.querySelectorAll('.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button');
    buttons.forEach(button => {
      const currentPortal = button.closest('.nm-portal');
      if (currentPortal === sizeOptionPortal) {
        updateButtonTextAndStyle(button);
        return;
      }
      if (currentPortal && currentPortal !== sizeOptionPortal && !currentPortal.hasAttribute('data-portal-location')) {
        sizeOptionPortal.appendChild(button);
        updateButtonTextAndStyle(button);
      }
      if (!currentPortal && button.parentElement !== sizeOptionPortal) {
        sizeOptionPortal.appendChild(button);
        updateButtonTextAndStyle(button);
      }
    });
    
    const buttonsInPortal = sizeOptionPortal.querySelectorAll('.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button');
    buttonsInPortal.forEach(button => {
      updateButtonTextAndStyle(button);
    });
    
    
    ensurePortalClickable();
  }
  
  function initButtonMover() {
    stylePortalContainer();
    moveButtonToSizeOption();
    initPortalPositioning();
    
    if (!observer) {
      observer = new MutationObserver((mutations) => {
        let shouldMove = false;
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1 && (
              node.classList?.contains('restock-alerts-notify-button') ||
              node.classList?.contains('PRODUCT_PAGE-notify-button') ||
              node.querySelector?.('.restock-alerts-notify-button, .PRODUCT_PAGE-notify-button')
            )) {
              shouldMove = true;
            }
          });
          mutation.removedNodes.forEach((node) => {
            if (node.nodeType === 1 && (
              node.classList?.contains('restock-alerts-notify-button') ||
              node.classList?.contains('PRODUCT_PAGE-notify-button')
            )) {
              shouldMove = true;
            }
          });
          if (mutation.target.classList?.contains('nm-portal')) {
            shouldMove = true;
          }
        });
        if (shouldMove) {
          moveButtonToSizeOption();
        }
      });
      
      if (document.body) {
        observer.observe(document.body, { childList: true, subtree: true });
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          observer.observe(document.body, { childList: true, subtree: true });
          moveButtonToSizeOption();
        });
      }
    }
    
    setTimeout(moveButtonToSizeOption, 100);
    setTimeout(moveButtonToSizeOption, 500);
    setTimeout(moveButtonToSizeOption, 1000);
    setTimeout(moveButtonToSizeOption, 2000);
    setTimeout(moveButtonToSizeOption, 3000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtonMover);
  } else {
    initButtonMover();
  }
  
  document.addEventListener('product-info:loaded', () => {
    setTimeout(initButtonMover, 50);
    setTimeout(initButtonMover, 200);
    setTimeout(initButtonMover, 500);
    setTimeout(initButtonMover, 1000);
    setTimeout(initButtonMover, 2000);
    setTimeout(initPortalPositioning, 100);
  });
  
  
  function handleVariantChange() {
    
    setTimeout(() => {
      attachLabelListeners();
      
      
      const activeLabel = document.querySelector('#size-option .product__size-variant-input:checked + .product__size-variant-label') ||
                         document.querySelector('#size-option .product__size-variant-label--disabled');
      if (activeLabel) {
        updatePortalTranslateX(activeLabel);
      }
      
      
      ensurePortalClickable();
      setTimeout(ensurePortalClickable, 50);
      setTimeout(ensurePortalClickable, 100);
      setTimeout(ensurePortalClickable, 200);
    }, 10);
  }
  
  
  document.addEventListener('change', (e) => {
    if (e.target.matches('.product__size-variant-input, .product__fit-variant-input, .product-option__input, input[type="radio"][name*="option"]')) {
      handleVariantChange();
    }
  });
  
  
  document.addEventListener('click', (e) => {
    if (e.target.matches('.product__size-variant-input, .product__size-variant-label, .product__fit-variant-input, .product__fit-variant-label, .product-option__input, .product-option__label')) {
      setTimeout(handleVariantChange, 10);
    }
  });
  
  
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    const formObserver = new MutationObserver(() => {
      handleVariantChange();
    });
    
    formObserver.observe(productForm, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });
  }
})();
